import React from 'react';
import SignUpPage from '../Signup/SignUpPage'

const Signup = () => {
  return (
<>
<SignUpPage/>
</>
  );
};

export default Signup;

